import Placeholder from "rsuite/esm/Placeholder";
import "rsuite/dist/rsuite.min.css";
import React from "react";

const ProductsOverviewSkeleton = () => {
    return (
        <React.Fragment>
            <div className="container-fluid px-0 bg-light mb-4">

                <div className="row product-list">
                    {[1, 2, 3].map((_, index) => (
                        <div className="col-lg-4 col-md-6 col-sm-12 card product-card" key={index} >
                            <div className="border rounded-3 bg-white p-3 h-100">
                                {/* Header */}
                                <div className="d-flex align-items-center justify-content-between mb-3 gap-2" style={{marginBottom: '5px'}}>
                                    <Placeholder.Graph
                                        active
                                        style={{ width: 80, height: 10 }}
                                    />
                                    <Placeholder.Graph
                                        active
                                        style={{
                                            width: 30,
                                            height: 12,
                                            borderRadius: 12,
                                        }}
                                    />
                                </div>

                                {/* Body */}
                                <div className="d-flex justify-content-between mb-2" style={{marginBottom: '5px'}}>
                                    <Placeholder.Graph active style={{ width: 30, height: 14 }} />
                                    <Placeholder.Graph active style={{ width: 50, height: 14 }} />
                                </div>

                                <div className="d-flex justify-content-between mb-2" style={{marginBottom: '5px'}}>
                                    <Placeholder.Graph active style={{ width: 50, height: 14 }} />
                                    <Placeholder.Graph active style={{ width: 60, height: 14 }} />
                                </div>

                                {/* <div className="d-flex justify-content-between">
                                    <Placeholder.Graph active style={{ width: 90, height: 14 }} />
                                    <Placeholder.Graph active style={{ width: 140, height: 14 }} />
                                </div> */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </React.Fragment>
    );
};

export default ProductsOverviewSkeleton;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/skeleton/ProductOverviewSkeleton.js